import {
  ApplicationPage,
  ApplicationViewHeader,
} from "../../../components/application";
import AssignedWorkSection from "../../facilitated-surfaces/components/AssignedWorkSection";

export default function AssignedWorkList() {
  return (
    <ApplicationPage variant="workspace">
      <ApplicationViewHeader
        contextLabel="Assigned Work"
        title="Assigned Work"
        description="Review activities assigned to you, then start, resume, or finish them."
      />
      <AssignedWorkSection />
    </ApplicationPage>
  );
}
